import { Plus } from '@squareup/dex-icons/dex/action';
import { EllipseSingle } from '@squareup/dex-icons/dex/misc';
import { TrackedProps } from '@squareup/dex-types-shared-utils';
import { NativeButton } from '@squareup/dex-ui';
import { Box, Paragraph20 } from '@squareup/dex-ui-shared-base';
import { commonIconStyles } from '@squareup/dex-ui-shared-icon-styles';
import clsx from 'clsx';
import React, { FC, PropsWithChildren } from 'react';

import styles from './api-explorer-field-helpers.module.css';

interface Props {
  onClick?: () => void;
  extraValuesTrigger?: React.ReactNode;
}

const ApiExplorerFieldAddButton: FC<
  PropsWithChildren<Props & TrackedProps>
> = ({ children, onClick, trackingId, trackingExtra, extraValuesTrigger }) => {
  return (
    <Box className={styles['flex-container']} margin={{ top: '1x' }}>
      <NativeButton
        className={styles['add-button']}
        onClick={onClick}
        trackingId={trackingId}
        testId="api-explorer-field-add-button"
        trackingExtra={trackingExtra}
      >
        <Plus className={commonIconStyles['icon-fill-current-color']} />
        <Paragraph20 weight="semi-bold" colorVariant="currentColor">
          {children}
        </Paragraph20>
      </NativeButton>
      {extraValuesTrigger && (
        <>
          <EllipseSingle
            className={clsx(
              styles['ellipse-divider'],
              commonIconStyles['icon-fill-circle-current-color']
            )}
          />
          {extraValuesTrigger}
        </>
      )}
    </Box>
  );
};

export { ApiExplorerFieldAddButton };
